import { UNIT_TASKS_COUNT_URL } from 'endpoints'
import { httpWrapper } from '../helpers/httpModule'

export const getCount = () =>
  httpWrapper({
    url: UNIT_TASKS_COUNT_URL,
    method: 'get'
  })
